//------------------------------------------------------------------------------
// プルダウンヘルパー
//------------------------------------------------------------------------------
import MenuItem from '@mui/material/MenuItem';

/**
 * プルダウン項目作成
 *
 * @param {string} value 項目値
 * @param {string} label 項目ラベル
 * @return {MenuItem} メニュー項目
 */
export function makeItem(value, label) {
  const key = 'item-' + value;
  return (
    <MenuItem key={key} value={value}>
      {label}
    </MenuItem>
  );
}

/**
 * プルダウン項目一覧作成
 *
 * @param {object[]} list 項目一覧
 *      - {string} value 項目値
 *      - {string} label 項目ラベル
 * @param {object?} defData 項目一覧が空の場合のデフォルト値
 */
export function makeItems(list, defData) {

  // 項目一覧作成
  const items = Array.isArray(list)
      ? list.map((data) => makeItem(data.value, data.label))
      : [];

  // 項目一覧が空の場合はデフォルト
  if (items.length === 0 && defData?.value) {
    const item = makeItem(
        defData.value,
        defData?.label || '');
    return [ item ];
  }
  return items;
}

// 空白 (改行なし空白)
export const NBSP = '\u00A0';

/**
 * 空のプルダウン項目
 */
export const EMPTY_ITEM = (
  <MenuItem key="item-(empty)" value="">
    {NBSP}
  </MenuItem>
);

/**
 * 空のプルダウン項目リスト(配列)
 */
export const EMPTY_LIST = [ EMPTY_ITEM ];

// デフォルトエクスポート
export default {
  makeItem,
  makeItems,
  NBSP,
  EMPTY_ITEM,
  EMPTY_LIST,
};
